import { Injectable } from "@angular/core";
import { Observable, Subject, catchError, map, of, pipe, throwError } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GetBranchesPaginatedCommand, IGetBranchesPaginatedCommandParameters, IGetBranchesPaginatedResponse } from "./command/getBranchesPaginated.command";
import { environment } from "environments/environment";
import { ConnectionServices } from "../authentication/connection/connection.service";
import { IdentityService } from "../authentication/identity.service";
import { MultiRegionService } from "../multiregion/multiregion.service";
import { SortEnum } from "../enum/sortEnum.enum";
import { AffiliateMovementPendingPaginatedDTO, AffiliateProfileResponseDto, CarrierRequestsGrid, CarrierUserPaginatedResponseDTO, GenericReportFiltersDTO, ICarrierBranchResponseDTO, LocalCompanyRegistrationRequestDto } from "../authentication/connection/interfaces/apiInterfaces";
import { GetAffiliateMovementPendingPaginatedCommand, IgetAffiliateMovementPendingPaginatedCommandParameters } from "./command/getAffiliateMovementPendingPaginated.command";
import { GetCarriersRequestsCommand, IGetCarriersRequestsCommandParameters } from "./command/getCarriersRequests.command";
import { GetAllCarrierCommand, IGetAllCarrierCommandParameters, IGetAllCarrierResponse } from "./command/getAllCarrier.command";
import { GetTravelShorcutsCommand, IGetTravelShortcutsParameters } from "./command/getTravelShorcuts.command";
import { GetCarrierParameterCommand, IGetCarrierParameterCommandParameters } from "./command/getCarrierParameter.command";
import { getAffiliateProfile } from "./command/getAffiliateProfile.command";
import { GetGenericReportCommand, IGetGenericReportParameters } from "./command/getGenericReportCommand";
import { GetSurrenderDailyReportCommand } from "./command/getSurrenderDailyReportCommand";
import { SyncWithOdnCommand, ISyncWithOdnParameters } from "./command/syncWithOdnCommand";
import { GetPassengerByAreaCommand } from "./command/getPassengerByAreaCommand";
import { GetUsersListCommand } from "./command/getUsersList.command";
import { GetGenericReportTotalCommand } from "./command/getGenericReportTravel.command";
import { GetCarrierCreditCardCommand, IGetCarrierCreditCardCommandParameters } from "./command/getCarrierCreditCard.command";
import { GetAffiliateLiquidationsListPaginatedCommand, IGetAffiliateLiquidationsListPaginatedCommandParameters, AffiLiquidationsPageResponse } from "./command/getAffiliateLiquidationsListPaginated.command";
import { GetAllCompanyNamesCommand, IGetAllCompanyNamesCommandParameters, IGetAllCompanyNamesResponse } from "./command/getAllCompanyNamesCommand";
import { CreateLocalCompanyCommand, CreateLocalCompanyCommandParameters } from "./command/createLocalCompany.command";
import { NotificationsService } from "../notifications/notifications.service";
import { IImportLocalCompanyResponse, ImportLocalCompanyCommand } from "../client/command/importLocalCompany.command";
import { TranslateService } from "@ngx-translate/core";
import { GetRecurringTripCommand, IGetRecurringTripCommandParameters, IGetRecurringTripResponse } from "./command/getRecurringTrip.command";
import { GetCanceledRecurringTripCommand, IGetCanceledRecurringTripCommandParameters, IGetCanceledRecurringTripResponse } from "./command/getCanceledRecurringTrip.command";
import { DeleteRecurringTripCommand, IDeleteRecurringTripCommandParameters } from "./command/deleteRecurringTrip.command";
import { EditRecurringTripCommand, IEditRecurringTripCommandParameters } from "./command/editRecurringTrip.command";
import { PostSendRecurrentNoteCommand, IPostSendRecurrentNote } from "./command/postSendRecurrentNote";
import { ICommandResponse } from "../authentication/connection/iCommandResponse";
import { GetOwnersFindCommand } from "./command/getOwnersFindCommand";
import { GetAllBranchesCommand, IGetAllBranchesCommandParameters, IGetAllBranchesResponse } from "./command/getAllBranches.command";
import { GetSurrenderReportCommand, IGetSurrenderReportCommandParameters } from "./command/getSurrenderReportCommand";
import { GetTotalsSurrenderCommand, IGetTotalsSurrenderCommandParameters, IGetTotalsSurrenderResponse } from "./command/getTotalsSurrenderCommand";
import { SurrenderReportPagesResponseDTO } from "../interfaces/apiInterfaces.d";
import { ConfigService } from "../authentication/connection/config.service";
import { GetTravelsCurrentStatusCommand, IGetTravelCurrentStatusCommandParameters } from "./command/getCarrierTravelCurrentStatus.command";
import { GetDriversDashboardCommand, IGetDriversDashboardParameters, IGetDriversDashboardResponse, DriverDashboardDTO } from "./command/getDriversDashboard.command";
import { GetDriversLastPlacesCommand, IGetDriversLastPlacesParameters, IGetDriversLastPlacesResponse } from "./command/getDriversLastPlaces.command";
import { TravelsCurrentStatus } from "../authentication/connection/interfaces/apiInterfaces";
import { GetEmailTemplatesCommand, IGetEmailTemplatesParameters } from "./command/getEmailTemplates.command";
import { PutEmailTemplateCommand, IPutEmailTemplateCommandParameters } from "./command/putEmailTemplate.command";
import { DeleteEmailTemplateCommand, IDeleteEmailTemplateCommandParameters } from "./command/deleteEmailTemplate.command";
import { PutEmailTemplateActiveCommand, IPutEmailTemplateActiveCommandParameters } from "./command/putEmailTemplateActive.command";
import { GetPassengerWithCheckingAccountByCarrierCommand, IGetPassengerWithCheckingAccountByCarrierParameters } from "./command/getPassengerWithCheckingAccountByCarrierCommand";
import { GetAssociatesByPrimaryPassengerIdCommand, IGetAssociatesByPrimaryPassengerIdParameters } from "./command/getAssociatesByPrimaryPassengerIdCommand";
import { GetAllBranchesV2Command, IGetAllBranchesV2CommandParameters } from "./command/getAllBranchesV2.command";
import { CreateCarrierBranchV2Command, CreateCarrierBranchV2CommandParameters } from "./command/createCarrierBranchV2.command";
import { UpdateCarrierBranchV2Command, UpdateCarrierBranchV2CommandParameters } from "./command/updateCarrierBranchV2.command";
import { UpdatePlatformStatusRTDBV2Command, IUpdatePlatformStatusRTDBV2Parameters } from "./command/updatePlatformStatusRTDBV2.command";
import { GetOperationCharacteristicsCommand } from "./command/getOperationCharacteristic.command";


@Injectable()
export class CarrierService {
  private titleMessage: string;
  visibilityCreditCardExpireDate$ = new Subject<{
    state: boolean;
    alertType: string; // warning, danger
    msj: string;
    msjLink?: string;
  }>();

  constructor(
    private _connectionService: ConnectionServices,
    private _notificationsService: NotificationsService,
    private _identityService: IdentityService,
    private _multiRegionService: MultiRegionService,
    private _translateService: TranslateService,
    private _http: HttpClient,
    private _configService: ConfigService
  ) { }

  changeVisibilityAlertCreditCardExpireDate(data: {
    state: boolean;
    alertType: string;
    msj: string;
    msjLink?: string;
  }) {
    this.visibilityCreditCardExpireDate$.next(data);
  }

  // public UpdateAccount(
  //   solicitudeId: number,
  //   data: CarrierSolicitudeUpdateDto
  // ): Observable<boolean> {
  //   const signUpCommand = new UpdateSolicitudeCommand();
  //   signUpCommand.setParameters(<IUpdateSolicitudeCommandParameters>{
  //     state: data.state,
  //     tributeNumberChecked: data.tributeNumberChecked,
  //     companyNameChecked: data.companyNameChecked,
  //     bankNameChecked: data.bankNameChecked,
  //     bankUniqueChecked: data.bankUniqueChecked,
  //     emailChecked: data.emailChecked,
  //     commercialLicenseChecked: data.commercialLicenseChecked,
  //     tributeConditionChecked: data.tributeConditionChecked,
  //     observations: data.observations,
  //     phoneNumberChecked: data.phoneNumberChecked,
  //     solicitudeId: solicitudeId.toString(),
  //   });
  //   return this._connectionService
  //     .Request(signUpCommand)
  //     .map((response) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.account.title',
  //         'toast.account.message.account_updated'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.account.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public getAccountSolicitude(
  //   solicitudeId: number
  // ): Observable<CarrierSolicitudeResponseDto> {
  //   let solicitudeCommand = new GetAccountSolicitudeCommand();
  //   solicitudeCommand.setParameters(<IGetAccountSolicitudeCommandParameters>{
  //     solicitudeId: solicitudeId,
  //   });

  //   return this._connectionService
  //     .Request(solicitudeCommand)
  //     .map((data) => {
  //       let response = data as CarrierSolicitudeResponseDto;
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.authentication.solicitude',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }
  // public resendSolicitude(carrierAccountSolicitudeId: Number) {
  //   let command = new CarrierAccountResendSolicitudeCommand();
  //   const params: ICarrierAccountResendSolicitudeParameters = {
  //     carrierAccountSolicitudeId: carrierAccountSolicitudeId,
  //   };
  //   command.setParameters(params);
  //   return this._connectionService
  //     .Request(command)
  //     .map((data) => {
  //       this._notificationsService.showSuccessMessage(
  //         'admin.accounts.title',
  //         'toast.general.resend_email_success'
  //       );
  //       return true;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showInternalErrorMessage(
  //         'admin.accounts.title',
  //         'toast.general.resend_email_error'
  //       );

  //       return Observable.throw(false);
  //     });
  // }

  // public resendCarrierUserSolicitude(carrierUserID: Number) {
  //   let command = new CarrierUserResendSolicitudeCommand();
  //   const params: ICarrierUserResendSolicitudeParameters = {
  //     carrierUserId: carrierUserID,
  //   };
  //   command.setParameters(params);
  //   return this._connectionService
  //     .Request(command)
  //     .map((data) => {
  //       this._notificationsService.showSuccessMessage(
  //         'carrier.configuration.users_profile.title',
  //         'toast.general.resend_email_success'
  //       );
  //       return true;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showInternalErrorMessage(
  //         'carrier.configuration.users_profile.title',
  //         'toast.general.resend_email_error'
  //       );

  //       return Observable.throw(false);
  //     });
  // }
  public getAllCompanyNames(carrierId: number): Observable<IGetAllCompanyNamesResponse[]> {
    const command = new GetAllCompanyNamesCommand();
    command.setParameters(<IGetAllCompanyNamesCommandParameters>{
      carrierId: carrierId,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as IGetAllCompanyNamesResponse[]),
        catchError((error) => {
          // this._notificationsService.showHttpErrorMessage(
          //   this.titleMessage,
          //   error
          // );
          return throwError(() => false);
        })
      );
  }
  public getCarriersRequests(
    page: number,
    size: number,
    column: string,
    sort: SortEnum,
    find: string
  ): Observable<CarrierRequestsGrid> {
    const driverCommand = new GetCarriersRequestsCommand();
    driverCommand.setParameters(<IGetCarriersRequestsCommandParameters>{
      column: column,
      page: page,
      size: size,
      sort: sort,
      find: find,
    });
    return this._connectionService
      .Request(driverCommand)
      .pipe(
        map(data => {
          const response = data as CarrierRequestsGrid;
          return response;
        }),
        catchError(() => {
          return throwError(false);
        })
      )


    // (driverCommand)
    // .map((data) => {
    //   const response = data as CarrierRequestsGrid;
    //   return response;
    // })
    // .catch((error) => {
    //   return Observable.throw(false);
    // });
  }

  // public changeSolicitudeToPending(
  //   id: number,
  //   token: string
  // ): Observable<boolean> {
  //   let statusCommand = new ChangeCarrierSolicitudeStatusCommand(id, token);
  //   return this._connectionService
  //     .Request(statusCommand)
  //     .map((data) => {
  //       return true;
  //     })
  //     .catch((error) => {
  //       return Observable.throw(error);
  //     });
  // }

  // public updateSettingParameter(
  //   id: number,
  //   travelPercentage: number
  // ): Observable<boolean> {
  //   let command = new UpdateSettingParameterCarrierCommand(id);
  //   command.setParameters(<IUpdateSSettingParameterCarrierCommandParameters>{
  //     travelPercentage: travelPercentage,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((data) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.parameters.carrier_parameters',
  //         'toast.parameters.message.carrier_parameters_updated'
  //       );
  //       return true;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.parameters.carrier_parameters',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public findByCarrierAndNameContains(
  //   termsCarrier: string,
  //   termsFirstName: string,
  //   termsLastName: string
  // ): Observable<IFindCarriersByCarrierOrFirstOrLastNameContainsResponse[]> {
  //   this.titleMessage = this._multiRegionService.getLabel(
  //     AdminDashboardEnum.ADMIN_DASHBOARD_TITLE_MESSAGE
  //   );
  //   const command = new FindCarriersByCarrierOrFirstOrLastNameContains();
  //   command.setParameters(<
  //     IFindCarriersByCarrierOrFirstOrLastNameContainsCommandParameters
  //     >{
  //       termsCarrier: termsCarrier,
  //       termsFirstName: termsFirstName,
  //       termsLastName: termsLastName,
  //     });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response as CarriersByCarrierOrFirstOrLastNameResponseDto;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         this.titleMessage,
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public getCarrierPreferenceById(
  //   carrierUserId: string
  // ): Observable<CarrierPreferences> {
  //   const command = new GetCarrierPreferenceCommand();
  //   command.setParameters(<IGetCarrierPreferenceCommandParameters>{
  //     carrierUserId: carrierUserId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         this.titleMessage,
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  public getCarrierParameterByKey(
    carrierUserId: string,
    key: string
  ): Observable<String> {
    const command = new GetCarrierParameterCommand();
    command.setParameters(<IGetCarrierParameterCommandParameters>{
      carrierUserId: carrierUserId,
      key: key,
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          return response as String;
        }),
        catchError((error) => {
          //     this._notificationsService.showHttpErrorMessage(
          //       this.titleMessage,
          //       error
          //     );
          return throwError(() => false);
        }));
  }

  // public getMercadoPagoAvailable(carrierUserId: string): Observable<String> {
  //   const command = new GetCarrierMercadoPagoAvailableCommand();
  //   command.setParameters(<IGetCarrierMercadoPagoAvailableCommandParameters>{
  //     carrierUserId: carrierUserId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         this.titleMessage,
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public UpdateCarrier(
  //   carrierPreferences: CarrierPreferences
  // ): Observable<CarrierPreferences> {
  //   const command = new UpdateCarrierCommand();
  //   command.setParameters(<IUpdateCarrierCommandParameters>{
  //     carrierUserId: carrierPreferences.carrierUserId,
  //     bankName: carrierPreferences.bankName,
  //     bankUniqueNumber: carrierPreferences.bankUniqueNumber,
  //     commercialLicense: carrierPreferences.commercialLicense,
  //     company: carrierPreferences.company,
  //     imageLogo: carrierPreferences.imageLogo,
  //     imageLogoMax: carrierPreferences.imageLogoMax,
  //     phoneNumber: carrierPreferences.phoneNumber,
  //     phoneNumberCommercial: carrierPreferences.phoneNumberCommercial,
  //     tributeCondition: carrierPreferences.tributeCondition,
  //     tributeNumber: carrierPreferences.tributeNumber,
  //     locationPlace: carrierPreferences.locationPlace,
  //     locationPlace2: carrierPreferences.locationPlace2,
  //     billingLocation: carrierPreferences.billingLocation,
  //     email: carrierPreferences.email,
  //     paymentMethod: carrierPreferences.paymentMethod,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.configuration.title',
  //         'toast.shared.message.update'
  //       );
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         this.titleMessage,
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public getSettlementParameters(
  //   carrierId: number,
  //   column: string,
  //   sort: string
  // ): Observable<PaginationResult<SettlementParametersResponse>> {
  //   const command = new GetSettlementParametersCommand();
  //   command.setUrlParameters(carrierId, column, sort);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response: PaginationResult<SettlementParametersResponse>) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       return Observable.throw(error);
  //     });
  // }

  // public saveSettlementParameters(
  //   carrierId: number,
  //   data: ISettlementParametersFormData
  // ): Observable<SettlementParametersResponse> {
  //   const command = new SaveSettlementParametersCommand(carrierId, data);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response: SettlementParametersResponse) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (error.error.errorCode === 'EXIST_SETTLEMENT_PARAMETER') {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.parameters.title',
  //           'toast.parameters.error_code.exist_settlement_parameter'
  //         );
  //       }
  //       return Observable.throw(error);
  //     });
  // }

  // // public deleteSettlementParameters(carrierId: number, parameterId: number): Observable<any> {
  // public deleteSettlementParameters(
  //   carrierId: number,
  //   parameterId: number
  // ): Observable<boolean> {
  //   const command = new DeleteSettlementParametersCommand();
  //   command.setUrlParameters(carrierId, parameterId);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return true;
  //     })
  //     .catch((error) => {
  //       return Observable.throw(error);
  //     });
  // }

  // public automaticTravelDispatch(
  //   carrierId: string,
  //   travelId: string
  // ): Observable<boolean> {
  //   const command = new AutomaticTravelDispatchCommand();
  //   command.setParameters(
  //     {
  //       carrierId: carrierId,
  //       travelId: travelId
  //     });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showInternalErrorMessage(
  //         'toast.carrier.common_error_title',
  //         'toast.carrier.automatic_dispatch_failed'
  //       );
  //       return Observable.throw(error);
  //     });
  // }

  // public stopAutomaticTravelDispatch(
  //   carrierId: string,
  //   travelId: string
  // ): Observable<boolean> {
  //   const command = new StopAutomaticDispatchCommand();
  //   command.setParameters(
  //     {
  //       carrierId: carrierId,
  //       travelId: travelId
  //     });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showInternalErrorMessage(
  //         'toast.carrier.common_error_title',
  //         'toast.carrier.automatic_dispatch_stop_failed'
  //       );
  //       return Observable.throw(error);
  //     });
  // }

  // getCarrierByMagiisNumber(
  //   magiisNumber: string
  // ): Observable<CarrierResponseDto> {
  //   const command = new GetCarrierByMagiisNumberCommand();
  //   const params: IGetCarrierByMagiisNumberCommandParameters = {
  //     magiisNumber,
  //   };
  //   command.setParameters(params);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response: CarrierResponseDto) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (error.error.errorCode === 'CARRIER_NOT_FOUND') {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.carrier.info',
  //           'toast.carrier.error_code.carrier_not_found'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.carrier.info',
  //           error
  //         );
  //       }
  //       return Observable.throw(error);
  //     });
  // }
  public createLocalCompany(
    data: LocalCompanyRegistrationRequestDto
  ): Observable<boolean> {
    let signUpCommand = new CreateLocalCompanyCommand();
    signUpCommand.setParameters(<CreateLocalCompanyCommandParameters>{
      imageLogo: data.imageLogo,
      companyName: data.companyName,
      companyFantasyName: data.companyFantasyName,
      tributeNumber: data.tributeNumber,
      tributeNumberImage: data.tributeNumberImage,
      email: data.email,
      checkingAccount: data.checkingAccount,
      checkingAccountLimit: data.checkingAccountLimit,
      exceedingLimit: data.exceedingLimit,
      expenseReportMode: data.expenseReportMode,
      phoneNumber: data.phoneNumber,
      password: data.password,
      country: data.country,
      locationPlace: data.locationPlace,
      billingPlace: data.billingPlace,
      carrierId: this._identityService.userId,
      carrierRateId: data.carrierRateId,
      acceptSimultaneousTrips: data.acceptSimultaneousTrips,
      addresses: data.addresses,
      editMode: false,
    });
    return this._connectionService
      .Request(signUpCommand)
      .pipe(
        map((signUpResponse) => {
          this._notificationsService.showSuccessMessage(
            'toast.contractor.client',
            'toast.carrier.message.register_success'
          );
          return true;
        }),
        catchError((error) => {
          return throwError(() => error);
        })
      );
  }

  public updateLocalCompany(
    data: LocalCompanyRegistrationRequestDto
  ): Observable<boolean> {
    let editCommand = new CreateLocalCompanyCommand();
    editCommand.setParameters(<CreateLocalCompanyCommandParameters>{
      imageLogo: data.imageLogo,
      companyName: data.companyName,
      companyFantasyName: data.companyFantasyName,
      tributeNumber: data.tributeNumber,
      tributeNumberImage: data.tributeNumberImage,
      email: data.email,
      checkingAccount: data.checkingAccount,
      checkingAccountLimit: data.checkingAccountLimit,
      exceedingLimit: data.exceedingLimit,
      expenseReportMode: data.expenseReportMode,
      phoneNumber: data.phoneNumber,
      password: data.password,
      country: data.country,
      locationPlace: data.locationPlace,
      billingPlace: data.billingPlace,
      carrierId: this._identityService.userId,
      carrierRateId: data.carrierRateId,
      editMode: true,
      acceptSimultaneousTrips: data.acceptSimultaneousTrips,
      id: data.id,
      addresses: data.addresses,
    });
    return this._connectionService
      .Request(editCommand)
      .pipe(
        map((editResponse) => {
          // this._notificationsService.showSuccessMessage(
          //   'toast.shared.edit',
          //   'toast.shared.message.edit'
          // );
          return true;
        }),
        catchError((error) => {
          if (error.status === 409) {
            this._notificationsService.showInternalErrorMessage(
              'toast.contractor.client',
              error.error.description
            );
            return of(true);
          }
          this._notificationsService.showHttpErrorMessage(
            'toast.shared.edit',
            error
          );
          return throwError(() => false);
        })
      );
  }

  public importContractors(csv: File,
    carrier: string, country: string, importType: string): Observable<IImportLocalCompanyResponse> {
    let importLocalCompanyCommand = new ImportLocalCompanyCommand();
    let form = new FormData()
    form.append('country', country)
    form.append('csv', csv, csv.name)
    form.append('file', csv, csv.name)
    form.append('carrier', carrier)
    form.append('importType', importType)
    importLocalCompanyCommand.setParameters(form);
    return this._connectionService
      .Request(importLocalCompanyCommand)
      .pipe(
        map(data => {
          if (data.successLines > 0) {
            this._notificationsService.showSuccessMessage(
              'toast.contractor.title',
              this._translateService.instant('carrier.clients.contractor_management.import.success_message')
                .replace('{lines}', data.successLines)
            );
          }
          return data;
        }),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage('toast.contractor.title', error);
          return throwError(() => false);
        })
      );
  }
  // createUserProfile(newUserRequest: CarrierUserRequestDTO): Observable<void> {
  //   let newUserProfileCommand = new CreateUserProfileCommand();
  //   newUserProfileCommand.setParameters(
  //     <CreateUserProfileCommandParameters>newUserRequest
  //   );
  //   return this._connectionService
  //     .Request(newUserProfileCommand)
  //     .map((signUpResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.carrier.profiles',
  //         'toast.users.message.user_created'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.status === 409) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.carrier.profiles',
  //           error.error.description
  //         );
  //         return of(true);
  //       }
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.carrier.profiles',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // deleteUserProfile(userId: number): Observable<void> {
  //   let newUserProfileCommand = new DeleteUserProfileCommand();
  //   newUserProfileCommand.setParameters({
  //     userId: userId,
  //   });
  //   return this._connectionService
  //     .Request(newUserProfileCommand)
  //     .map((signUpResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.carrier.profiles',
  //         'toast.users.message.user_deleted'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.status === 409) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.carrier.profiles',
  //           error.error.description
  //         );
  //         return of(true);
  //       }
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.carrier.profiles',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  public getCarrierUsers(
    numberPage: number,
    rowsOnPage: number,
    sortField: string,
    sortOrder: SortEnum
  ): Observable<CarrierUserPaginatedResponseDTO> {
    const getUsersListCommand = new GetUsersListCommand();
    getUsersListCommand.setParameters({
      carrierUserId: Number(this._identityService.userId),
      page: numberPage,
      size: rowsOnPage,
      column: sortField,
      sort: sortOrder,
    });
    return this._connectionService
      .Request(getUsersListCommand)
      .pipe(
        map((response) => {
          return response as CarrierUserPaginatedResponseDTO;
        }),
        catchError((error) => {
          /*
          if (error.status === 409) {
            this._notificationsService.showInternalErrorMessage(
              'toast.carrier.profiles',
              error.error.description
            );
            return of(true);
          }
          this._notificationsService.showHttpErrorMessage(
            'toast.carrier.profiles',
            error
          );
          */
          return throwError(false);
        })
      )
  }

  // updateUserProfile(userRequestDTO: CarrierUserRequestDTO) {
  //   let newUserProfileCommand = new UpdateUserProfileCommand();
  //   newUserProfileCommand.setParameters(userRequestDTO);
  //   return this._connectionService
  //     .Request(newUserProfileCommand)
  //     .map((signUpResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.carrier.profiles',
  //         'toast.users.message.user_edited'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.status === 400) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.carrier.profiles',
  //           'toast.users.error_code.' + error.error.errorCode
  //         );
  //         return of(true);
  //       }

  //       if (error.status === 409) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.carrier.profiles',
  //           error.error.description
  //         );
  //         return of(true);
  //       }
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.carrier.profiles',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // deleteBranch(id: number): Observable<void> {
  //   let deleteCarrierBranchCommand = new DeleteCarrierBranchCommand();
  //   deleteCarrierBranchCommand.setParameters({
  //     carrierId: Number(this._identityService.userId),
  //     branchId: id,
  //   });
  //   return this._connectionService
  //     .Request(deleteCarrierBranchCommand)
  //     .map((signUpResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.branches.title',
  //         'toast.branches.message.branch_deleted'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.status > 400 && error.status < 420) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.branches.title',
  //           error.error.description
  //         );
  //         return of(true);
  //       }
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.branches.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // createBranch(branch: ICarrierBranchResponseDTO): Observable<boolean> {
  //   let signUpCommand = new CreateCarrierBranchCommand();
  //   signUpCommand.setParameters(<CreateCarrierBranchCommandParameters>{
  //     carrierId: this._identityService.userId,
  //     branchName: branch.branchName,
  //     branchType: branch.branchType,
  //     phone: branch.phone,
  //     locationPlace: branch.locationPlace,
  //     operationRadius: branch.operationRadius,
  //     melita: branch.melita
  //   });
  //   return this._connectionService
  //     .Request(signUpCommand)
  //     .map((signUpResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.branches.title',
  //         'toast.branches.message.branch_created'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.status > 400 && error.status < 420) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.branches.title',
  //           error.error.description
  //         );
  //         return of(true);
  //       }
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.branches.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }
  // updateBranch(branch: ICarrierBranchResponseDTO): Observable<boolean> {
  //   let signUpCommand = new UpdateCarrierBranchCommand();
  //   signUpCommand.setParameters(<UpdateCarrierBranchCommandParameters>{
  //     carrierId: this._identityService.userId,
  //     id: branch.id,
  //     branchName: branch.branchName,
  //     branchType: branch.branchType,
  //     phone: branch.phone,
  //     locationPlace: branch.locationPlace,
  //     operationRadius: branch.operationRadius,
  //     melita: branch.melita
  //   });
  //   return this._connectionService
  //     .Request(signUpCommand)
  //     .map((signUpResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.branches.title',
  //         'toast.branches.message.branch_edited'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.status > 400 && error.status < 420) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.branches.title',
  //           error.error.description
  //         );
  //         return of(true);
  //       }
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.branches.title',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // ---- Branch methods (MX-5613) ----

  getBranchesPaginated(params: Omit<IGetBranchesPaginatedCommandParameters, 'carrierId'>): Observable<IGetBranchesPaginatedResponse> {
    const command = new GetBranchesPaginatedCommand();
    command.setParameters({
      carrierId: +this._identityService.userId,
      ...params,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as unknown as IGetBranchesPaginatedResponse),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage('toast.branches.title', error);
          return throwError(() => error);
        })
      );
  }

  deleteBranch(id: number): Observable<boolean> {
    const carrierId = this._identityService.userId;
    const url = `${environment.apiUrl}carriers/${carrierId}/branch/${id}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this._identityService.sessionToken}`
    });
    return this._http.delete<any>(url, { headers }).pipe(
      map(() => {
        this._notificationsService.showSuccessMessage(
          'toast.branches.title',
          'toast.branches.message.branch_deleted'
        );
        return true;
      }),
      catchError(error => {
        if (error.status > 400 && error.status < 420) {
          this._notificationsService.showInternalErrorMessage(
            'toast.branches.title',
            error.error?.description || error.message
          );
        } else {
          this._notificationsService.showHttpErrorMessage('toast.branches.title', error);
        }
        return throwError(() => error);
      })
    );
  }
  // ---- End branch methods ----

  public getAllCarriers(
    countryId: string,
    province: string
  ): Observable<IGetAllCarrierResponse[]> {
    const command = new GetAllCarrierCommand();

    command.setParameters(<IGetAllCarrierCommandParameters>{
      country: countryId,
      province: province,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          // Puedes descomentar esta línea si quieres mostrar un mensaje de error
          // this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
          return throwError(() => new Error('Error al obtener los carriers'));
        })
      );
  }

  public getAllBranches(): Observable<ICarrierBranchResponseDTO[]> {
    const command = new GetAllBranchesV2Command();
    command.setParameters(<IGetAllBranchesV2CommandParameters>{
      carrierId: +this._identityService.userId,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
          return throwError(() => error);
        })
      );
  }

  public createBranch(branch: ICarrierBranchResponseDTO): Observable<any> {
    const command = new CreateCarrierBranchV2Command();
    command.setParameters(<CreateCarrierBranchV2CommandParameters>{
      carrierId: this._identityService.userId,
      branchName: branch.branchName,
      branchType: branch.branchType,
      phone: branch.phone,
      locationPlace: branch.locationPlace,
      operationRadius: branch.operationRadius,
      melita: branch.melita,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
          return throwError(() => error);
        })
      );
  }

  public updateBranch(branch: ICarrierBranchResponseDTO): Observable<any> {
    const command = new UpdateCarrierBranchV2Command();
    command.setParameters(<UpdateCarrierBranchV2CommandParameters>{
      carrierId: this._identityService.userId,
      id: branch.id,
      branchName: branch.branchName,
      branchType: branch.branchType,
      phone: branch.phone,
      locationPlace: branch.locationPlace,
      operationRadius: branch.operationRadius,
      melita: branch.melita,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
          return throwError(() => error);
        })
      );
  }

  public updatePlatformStatusRTDB(nodo: string): Observable<any> {
    const command = new UpdatePlatformStatusRTDBV2Command();
    command.setParameters(<IUpdatePlatformStatusRTDBV2Parameters>{
      carrierId: this._identityService.userId,
      nodo: nodo,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
          return throwError(() => error);
        })
      );
  }

  getGenericReport(
    numberPage: number,
    rowsOnPage: number,
    column: string,
    sort: SortEnum,
    reportCode: string,
    filters: Array<GenericReportFiltersDTO>,
    isOrderer?: boolean,
  ) {
    const command = new GetGenericReportCommand();
    command.setParameters(<IGetGenericReportParameters>{
      page: numberPage,
      column: column,
      sort: sort,
      size: rowsOnPage,
      reportCode: reportCode,
      filters: filters,
      isOrderer: isOrderer,
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          // Puedes descomentar esta línea si quieres mostrar un mensaje de error
          // this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
          return throwError(() => new Error('Error al obtener los datos para el reporte generico'));
        })
      );
    // return this._connectionService
    //   .Request(command)
    //   .map((response) => {
    //     return response;
    //   })
    //   .catch((error) => {
    //     this._notificationsService.showHttpErrorMessage(
    //       'toast.shared.error_code.0',
    //       error
    //     );
    //     return Observable.throw(false);
    //   });
  }

  getGenericReportTotal(
    numberPage: number,
    rowsOnPage: number,
    column: string,
    sort: SortEnum,
    reportCodeT: string,
    filters: Array<GenericReportFiltersDTO>,
    travelList?: boolean
  ) {
    let command;
    if (travelList) {
      command = new GetGenericReportTotalCommand();
    } else {
      command = new GetGenericReportCommand();
    }
    command.setParameters(<IGetGenericReportParameters>{
      page: numberPage,
      column: column,
      sort: sort,
      size: rowsOnPage,
      reportCode: reportCodeT,
      filters: filters,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          // Puedes descomentar esta línea si quieres mostrar un mensaje de error
          // this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
          return throwError(() => new Error('Error al obtener los datos para reporte generico de totals'));
        })
      );

    // return this._connectionService
    //   .Request(command)
    //   .map((response) => {
    //     return response;
    //   })
    //   .catch((error) => {
    //     this._notificationsService.showHttpErrorMessage(
    //       'toast.shared.error_code.0',
    //       error
    //     );
    //     return Observable.throw(false);
    //   });
  }


  getSurrenderDailyReport(carrierId: number, dateFrom: string, dateTo: string) {
    const command = new GetSurrenderDailyReportCommand();
    command.setParameters({ carrierId, dateFrom, dateTo });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }

  getAffiliateLiquidationsListPaginated(
    params: IGetAffiliateLiquidationsListPaginatedCommandParameters
  ): Observable<AffiLiquidationsPageResponse> {
    const command = new GetAffiliateLiquidationsListPaginatedCommand();
    command.setParameters(params);
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as unknown as AffiLiquidationsPageResponse),
        catchError(() => throwError(() => new Error('Error al obtener liquidaciones de afiliado')))
      );
  }

  getOperationCharacteristics() {
    const command = new GetOperationCharacteristicsCommand();
    return this._connectionService
      .Request(command)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError((error) => {
          this._notificationsService.showHttpErrorMessage(
            'toast.shared.error_code.0',
            error
          );
          return throwError(() => false);
        })
      );
  }
  _getAffiliateProfile(
    data: AffiliateProfileResponseDto
  ): Observable<AffiliateProfileResponseDto> {
    const command = new getAffiliateProfile();
    command.setParameters(data);

    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          return response as AffiliateProfileResponseDto;
        }),
        catchError((error) => {
          // Aquí podrías mostrar un mensaje de error si tienes el servicio de notificaciones disponible
          // this._notificationsService.showHttpErrorMessage(
          //   'toast.shared.error_code.0',
          //   error
          // );
          return throwError(() => false);
        })
      );
    // return this._connectionService
    //   .Request(command)
    //   .map((response) => {
    //     // tslint:disable-next-line:no-shadowed-variable
    //     let data = response as AffiliateProfileResponseDto;
    //     return data;
    //   })
    //   .catch((error) => {
    //     this._notificationsService.showHttpErrorMessage(
    //       'toast.shared.error_code.0',
    //       error
    //     );
    //     return Observable.throw(false);
    //   });
  }

  // getContractors(
  //   numberPage: number,
  //   column: string,
  //   size: number,
  //   sort: SortEnum,
  //   find: string
  // ) {
  //   const command = new GetContractorsCommand();
  //   command.setParameters(<IGetContractorsParameters>{
  //     page: numberPage,
  //     column: column,
  //     sort: sort,
  //     size: size,
  //     carrierId: this._identityService.userId,
  //     find: find,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getQRDataIntegration(
  //   username: string,
  //   password: string,
  //   idCarrier: string,
  //   lang: string,
  //   path: string,
  //   car: string,
  //   option: string,
  //   message: string,
  //   selectOption: string,
  //   messageHelp: string,
  //   messageOther: string,
  //   responderType: string
  // ) {
  //   const command = new GetQRDataWhatsApp();
  //   command.setParameters(<IGetQRDataWhatsAppParameters>{
  //     username: username,
  //     password: password,
  //     idCarrier: idCarrier,
  //     lang: lang,
  //     path: path,
  //     car: car,
  //     option: option,
  //     message: message,
  //     selectOption: selectOption,
  //     messageHelp: messageHelp,
  //     messageOther: messageOther,
  //     responderType: responderType
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  getCreditCards(carrierUserId: string) {
    const command = new GetCarrierCreditCardCommand();
    command.setParameters(<IGetCarrierCreditCardCommandParameters>{
      carrierUserId: carrierUserId,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(() => of([]))
      );
  }

  // postSendRecurrentNote(recurringId: number, note: string) {
  //   const command = new PostSendRecurrentNoteCommand(recurringId, note);
  //   command.setParameters(<IPostSendRecurrentNote>{
  //     note: note,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  getEmailTemplates(idCarrier: number, language?: string) {
    const command = new GetEmailTemplatesCommand();
    command.setParameters({
      idCarrier: idCarrier,
      language: language
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as any),
        catchError((error) => {
          this._notificationsService.showHttpErrorMessage(
            'toast.shared.error_code.0',
            error
          );
          return throwError(() => false);
        })
      );
  }

  restoreEmailTemplate(idTemplate: number) {
    const command = new DeleteEmailTemplateCommand();
    command.setParameters({
      idTemplate: idTemplate
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as any),
        catchError((error) => {
          this._notificationsService.showHttpErrorMessage(
            'toast.shared.error_code.0',
            error
          );
          return throwError(() => false);
        })
      );
  }

  getTravelShortcuts(carrierId: number) {
    const command = new GetTravelShorcutsCommand();
    command.setParameters(<IGetTravelShortcutsParameters>{
      idCarrier: carrierId,
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          const response = data as any;
          return response;
        }),
        catchError((err) => {
          // this._notificationsService.showHttpErrorMessage(
          //   'toast.shared.error_code.0',
          //   error
          // );
          return throwError(err);
        })
      )
  }

  putEmailTemplate(carrierId: number, email: any) {
    const command = new PutEmailTemplateCommand();
    command.setParameters({
      carrierId: carrierId,
      id: email.id,
      userId: email.userId,
      html: email.html,
      logoPlacement: email.logoPlacement,
      languageCode: email.languageCode,
      userType: email.userType
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as any),
        catchError((error) => {
          this._notificationsService.showHttpErrorMessage(
            'toast.shared.error_code.0',
            error
          );
          return throwError(() => false);
        })
      );
  }

  putEmailTemplateActive(carrierId: number, email: any) {
    const command = new PutEmailTemplateActiveCommand();
    command.setParameters({
      carrierId: carrierId,
      id: email.id,
      active: email.active,
      html: email.html,
      logoPlacement: email.logoPlacement,
      languageCode: email.languageCode,
      userId: email.userId,
      userType: email.userType
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as any),
        catchError((error) => {
          this._notificationsService.showHttpErrorMessage(
            'toast.shared.error_code.0',
            error
          );
          return throwError(() => false);
        })
      );
  }

  // putCarrierShortcut(carrierId: number, travelShortcutDTO: TravelShortcutRequestDTO) {
  //   const command = new PutCarrierShortcutCommand();
  //   command.setParameters(<ICarrierShortcutParameters>{
  //     carrierId: carrierId,
  //     shortcutId: travelShortcutDTO.shortcutId,
  //     shortcutName: travelShortcutDTO.shortcutName,
  //     passengerUserId: travelShortcutDTO.passengerUserId,
  //     idForCarrier: travelShortcutDTO.idForCarrier,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getAffiliateOneShotTravel(
  //   data: IGetAffiliateOneShotTravelCommandParameters
  // ): Observable<AffiliateOneShotTravelDto> {
  //   const command = new GetAffiliateOneShotTravelCommand();
  //   command.setParameters(data);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response as AffiliateOneShotTravelDto;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.affiliate.one_shot.quote.error_code.get_quote_error',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // putAffiOneShotTravelQuotingTravel(
  //   data: IPutAffiOneShotTravelQuotingTravelParameters
  // ): Observable<IPutAffiOneShotTravelQuotingTravelResponse> {
  //   const command = new PutAffiOneShotTravelQuotingTravelCommand();
  //   command.setParameters(data);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.shared.edit',
  //         'toast.shared.message.update'
  //       );
  //       return response as IPutAffiOneShotTravelQuotingTravelResponse;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.affiliate.one_shot.quote.error_code.put_quote_error',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // putAffiOneShotTravelAcceptOSTravelAgreement(
  //   data: IPutAffiOneShotTravelAcceptOSTravelAgreementParameters
  // ): Observable<IPutAffiOneShotTravelAcceptOSTravelAgreementResponse> {
  //   const command = new PutAffiOneShotTravelAcceptOSTravelAgreementCommand();
  //   command.setParameters(data);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.shared.edit',
  //         'toast.shared.message.update'
  //       );
  //       return response as IPutAffiOneShotTravelAcceptOSTravelAgreementResponse;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.affiliate.one_shot.quote.error_code.accept_quote_error',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _createTravelReserve(
  //   affiOSTravelId: number,
  //   agreementId: number,
  //   markUp: number,
  //   affiliateProfileId: number
  // ) {
  //   const command = new CreateTravelReserveCommand();
  //   command.setParameters({
  //     affiOSTravelId: affiOSTravelId,
  //     affiAgreementId: agreementId,
  //     markup: markUp,
  //     originToken: this._identityService.firebaseToken,
  //     affiliateProfileId: affiliateProfileId,
  //     userId: this._identityService.subUserId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (error.status === 406) {
  //         if (!!error.error.errorCode) {
  //           if (error.error.errorCode === 'AFFILIATE_CC_WARRANTY_EXPIRED') {
  //             this._notificationsService.showInternalErrorMessage(
  //               'toast.travels.title',
  //               'toast.travels.error_code.affiliate_cc_warranty_expired'
  //             );
  //           }
  //         }
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.shared.error_code.0',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // public saveAffiliateProfile(
  //   data: AffiliateProfileResponseDto
  // ): Observable<AffiliateProfileResponseDto> {
  //   const command = new SaveAffiliateProfileCommand(data);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response: AffiliateProfileResponseDto) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.configuration.title',
  //         'toast.shared.message.update'
  //       );
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         this.titleMessage,
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public UpdateAffiliateProfile(
  //   data: AffiliateProfileResponseDto
  // ): Observable<AffiliateProfileResponseDto> {
  //   const command = new updateAffiliateProfile();
  //   command.setParameters(data);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.configuration.title',
  //         'toast.shared.message.update'
  //       );
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         this.titleMessage,
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _getAffiliateAgreementsOneShotRequested(
  //   affiRequestedId: number,
  //   sort: string,
  //   column: string,
  //   page: number,
  //   size: number,
  //   countryId: number,
  //   provinceId: number,
  //   status: string,
  //   affiliateType: string,
  //   magiisQualificationFrom: number,
  //   magiisQualificationTo: number,
  //   find: string
  // ): Observable<AffiliateAgreementOneshotResponseDTO> {
  //   const command = new getAffiliateAgreementsOneShotRequestedCommand();
  //   const params =
  //     status === '6'
  //       ? {
  //           affiRequestedId: affiRequestedId,
  //           sort: sort,
  //           column: column,
  //           page: page,
  //           size: size,
  //           countryId: countryId,
  //           provinceId: provinceId,
  //           affiliateType: affiliateType,
  //           magiisQualificationFrom: magiisQualificationFrom,
  //           magiisQualificationTo: magiisQualificationTo,
  //           find: find,
  //           osTravelStatus: '0',
  //         }
  //       : {
  //           affiRequestedId: affiRequestedId,
  //           sort: sort,
  //           column: column,
  //           page: page,
  //           size: size,
  //           countryId: countryId,
  //           provinceId: provinceId,
  //           status: status,
  //           affiliateType: affiliateType,
  //           magiisQualificationFrom: magiisQualificationFrom,
  //           magiisQualificationTo: magiisQualificationTo,
  //           find: find,
  //         };

  //   command.setParameters(
  //     <IgetAffiliateAgreementsOneShotRequestedCommandParameters>params
  //   );
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as AffiliateAgreementOneshotResponseDTO;
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _getAffiliateAgreementsOneShotReceived(
  //   affiOffererId: string,
  //   sort: string,
  //   column: string,
  //   page: number,
  //   size: number,
  //   countryId: number,
  //   provinceId: number,
  //   status: string,
  //   affiliateType: string,
  //   magiisQualificationFrom: number,
  //   magiisQualificationTo: number,
  //   find: string
  // ): Observable<AffiliateAgreementOneshotResponseDTO> {
  //   const command = new getAffiliateAgreementsOneShotReceivedCommand();
  //   command.setParameters(<
  //     IgetAffiliateAgreementsOneShotReceivedCommandParameters
  //   >{
  //     affiOffererId: affiOffererId,
  //     sort: sort,
  //     column: column,
  //     page: page,
  //     size: size,
  //     countryId: countryId,
  //     provinceId: provinceId,
  //     status: status,
  //     affiliateType: affiliateType,
  //     magiisQualificationFrom: magiisQualificationFrom,
  //     magiisQualificationTo: magiisQualificationTo,
  //     find: find,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as AffiliateAgreementOneshotResponseDTO;
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public deActivateAffiliateOneShotAgremment(
  //   data: IdeActivateAffiliateOneShotAgremmentParammeters
  // ): Observable<AffiliateProfileResponseDto> {
  //   const command = new deActivateAffiliateOneShotAgremmentCommand();
  //   command.setParameters(data);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.shared.edit',
  //         'toast.shared.message.update'
  //       );
  //     })
  //     .catch((error) => {
  //       if (error.error.errorCode === 'AFFILIATE_ONE_SHOT_TRAVEL_BAD_STATE') {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.carrier.affiliate.error_code.decline_agreement_title',
  //           'toast.carrier.affiliate.error_code.decline_agreement_travel_in_course'
  //         );
  //       }else{
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.shared.error_code.0',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // _getAffiliateProfilePaginated(
  //   profId: number,
  //   sort: string,
  //   column: string,
  //   page: number,
  //   size: number,
  //   find: string,
  //   selectedCountry: string,
  //   selectedProvince: string,
  //   selectedServiceType: string,
  //   minCalification: number,
  //   maxCalification: number,
  //   minFleetSize: number,
  //   maxFleetSize: number,
  //   status: string[],
  //   tags: string[]
  // ): Observable<AffiliateProfilesPaginatedResponseDTO> {
  //   const command = new getAffiliateProfilesPaginatedCommand();
  //   command.setParameters(<IgetAffiliateProfilePaginatedCommandParameters>{
  //     profId: profId,
  //     sort: sort,
  //     column: column,
  //     page: page,
  //     size: size,
  //     find: find,
  //     selectedCountry: selectedCountry,
  //     selectedProvince: selectedProvince,
  //     selectedServiceType: selectedServiceType,
  //     minCalification: minCalification,
  //     maxCalification: maxCalification,
  //     minFleetSize: minFleetSize,
  //     maxFleetSize: maxFleetSize,
  //     statusList: status,
  //     tagsList: tags,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as AffiliateProfilesPaginatedResponseDTO;
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _getProfileRequestPaginated(
  //   sort: string,
  //   column: string,
  //   page: number,
  //   size: number,
  //   find: string,
  //   selectedCountry: string,
  //   selectedProvince: string,
  //   selectedInvitation: string,
  //   minCalification: number,
  //   maxCalification: number,
  //   selectedAffiliateTypes: string,
  //   pAffiProviderId: number
  // ): Observable<AffiliateAgreementsPaginatedResponseDTO> {
  //   const command = new getAffiliateRequestPaginatedCommand();
  //   command.setParameters(<getAffiliateRequestPaginatedCommandParameters>{
  //     sort: sort,
  //     column: column,
  //     page: page,
  //     size: size,
  //     find: find,
  //     selectedCountry: selectedCountry,
  //     selectedProvince: selectedProvince,
  //     selectedInvitation: selectedInvitation,
  //     minCalification: minCalification,
  //     maxCalification: maxCalification,
  //     selectedAffiliateTypes: selectedAffiliateTypes,
  //     pAffiProviderId: pAffiProviderId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as AffiliateAgreementsPaginatedResponseDTO;
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _declineAgremmentInvitation(
  //   declineAffiAgremmentParameters: IDeclineAffiAgremmentParameters
  // ): Observable<IDeclineAffiAgremmentResponse> {
  //   const command = new DeclineAffiAgremmentCommand();
  //   command.setParameters(declineAffiAgremmentParameters);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as DeclineAffiAgreementResponse;
  //       this._notificationsService.showSuccessMessage(
  //         'toast.shared.edit',
  //         'toast.carrier.affiliate.decline_agreement_success'
  //       );
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _sendAgremmentInvitation(
  //   affiliateProviderId: number,
  //   affiliateRequesterId: number,
  //   emissionUserId: number,
  //   id: number,
  //   agreementNo: string,
  //   messageNote: string,
  //   rqtTripTypes: {
  //     available: number;
  //     onDemmand: number;
  //     programmed: number;
  //   }
  // ): Observable<sendAgremmentInvitationResponseDTO> {
  //   const command = new SendAgremmentInvitationCommand();
  //   const params: ISendAgremmentInvitationParameters = {
  //     affiliateProviderId: affiliateProviderId,
  //     affiliateRequesterId: affiliateRequesterId,
  //     emissionUserId: emissionUserId,
  //     agreementNo: agreementNo,
  //     messageNote: messageNote,
  //     rqtTripTypes: rqtTripTypes,
  //   };
  //   command.setParameters(<ISendAgremmentInvitationParameters>params);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as sendAgremmentInvitationResponseDTO;
  //       this._notificationsService.showSuccessMessage(
  //         'toast.shared.edit',
  //         'toast.shared.message.edit'
  //       );
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _getAffiliateAccountBalancesPaginated(
  //   affiliateId: string,
  //   affiliateType: string,
  //   balanceSign: string,
  //   column: string,
  //   countryId: string,
  //   findFilter: string,
  //   page: string,
  //   size: string,
  //   sort: string
  // ): Observable<AffiliateAccountBalancesPaginatedResponseDTO> {
  //   const command = new GetAffiliateAccountBalancesPaginatedCommand();
  //   command.setParameters(<
  //     IgetAffiliateAccountBalancesPaginatedCommandParameters
  //   >{
  //     affiliateId: affiliateId,
  //     affiliateType: affiliateType,
  //     balanceSign: balanceSign,
  //     column: column,
  //     countryId: countryId,
  //     findFilter: findFilter,
  //     page: page,
  //     size: size,
  //     sort: sort,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as AffiliateAccountBalancesPaginatedResponseDTO;
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  _getAffiliateMovementPendingPaginated(
    dateTo: Date,
    affiliateId: number,
    page: number,
    size: number,
    column: string,
    sort: string,
    checkingAccId: number
  ): Observable<AffiliateMovementPendingPaginatedDTO> {
    const command = new GetAffiliateMovementPendingPaginatedCommand();
    command.setParameters(<IgetAffiliateMovementPendingPaginatedCommandParameters>{
      dateTo: dateTo,
      affiliateId: affiliateId,
      page: page,
      size: size,
      column: column,
      sort: sort,
      checkingAccId: checkingAccId,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response) => response as AffiliateMovementPendingPaginatedDTO),
        catchError(() => throwError(() => false))
      );
  }

  // _getAffiliateAgreementsTransferData(
  //   agreementId: number
  // ): Observable<AffiliateAgreementsTransferDataResponseDTO> {
  //   const command = new getAffiliateAgreementsTransferDataCommand();
  //   command.setParameters(<IAffiliateAgreementsTransferDataCommandParameters>{
  //     agreementId: agreementId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as AffiliateAgreementsTransferDataResponseDTO;
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _getWitnessTrips(
  //   agreementId: number,
  //   defaultFare: any,
  //   transportType: number
  // ): Observable<WitnessTripsResponseDTO> {
  //   const command = new getWitnessTripsCommand();
  //   command.setParameters(<IWitnessTripsCommandParameters>{
  //     agreementId: agreementId,
  //     carrierRate: defaultFare,
  //     transportType: transportType,
  //     carrierId: +this._identityService.userId
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as WitnessTripsResponseDTO[];
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _getDistanceTimeForRouteAndProviders(
  //   routeList: Array<any>,
  //   serviceList: Array<any>,
  //   affiProfileRequesterId: number,
  //   options: OptionsTravel
  // ) {
  //   const command = new getDistanceTimeForRouteAndProvidersCommand();
  //   command.setParameters(<
  //     IgetDistanceTimeForRouteAndProvidersCommandParameters
  //   >{
  //     routeList: routeList,
  //     serviceTypesList: serviceList,
  //     affiProfileRequesterId: affiProfileRequesterId,
  //     fastestRoute: options.fastestRoute,
  //     avoidTolls: options.avoidTolls,
  //     avoidHighways: options.avoidHighways,
  //     roundTrip: options.roundTrip
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as AffiliateProfilesPaginatedResponseDTO;
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _createOSTravelAgreementCommand(formData: {
  //   affiProfileRequesterId: number;
  //   offerers: Array<number>;
  //   name: string;
  //   currency: string;
  //   distance: number;
  //   dropRadio: number;
  //   duration: number;
  //   id: number;
  //   observations: string;
  //   vehicleQty: number;
  //   passegerQty: number;
  //   pickupRadio: number;
  //   reverse: number;
  //   roundTrip: boolean;
  //   destination: [
  //     {
  //       accuracy: number;
  //       id: number;
  //       latitude: string;
  //       longitude: string;
  //       placeId: string;
  //       shortName: string;
  //     }
  //   ];
  //   serviceType: Array<number>;
  //   start: string;
  //   end: string;
  //   waitTime: number;
  //   passenger: number;
  //   paymentMethod: string;
  //   rentType?: string;
  //   rentHours?: number;
  //   avoidHighways?: boolean;
  //   avoidTolls?: boolean;
  //   fastestRoute?: boolean;
  // }) {
  //   const command = new createOSTravelAgreementCommand();
  //   command.setParameters(<IcreateOSTravelAgreementCommandParameters>{
  //     affiProfileRequesterId: formData.affiProfileRequesterId,
  //     affiliateProfileList: formData.offerers,
  //     agreementName: formData.name,
  //     currency: formData.currency,
  //     distance: formData.distance,
  //     dropoffRadius: formData.dropRadio,
  //     duration: formData.duration,
  //     id: formData.id,
  //     notes: formData.observations,
  //     passengerQty: formData.passegerQty,
  //     pickupRadius: formData.pickupRadio,
  //     reverse: formData.reverse,
  //     roundTrip: formData.roundTrip,
  //     routeList: formData.destination,
  //     serviceTypesList: formData.serviceType,
  //     travelDate: formData.start,
  //     travelDueDate: formData.end,
  //     vehicleQty: formData.vehicleQty,
  //     waitingTime: formData.waitTime,
  //     passenger: formData.passenger,
  //     paymentMethod: formData.paymentMethod,
  //     rentType: formData.rentType,
  //     rentHours: formData.rentHours,
  //     avoidHighways: formData.avoidHighways,
  //     avoidTolls: formData.avoidTolls,
  //     fastestRoute: formData.fastestRoute
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as AffiliateProfilesPaginatedResponseDTO;
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _sendOSTravelAgreementCommand(
  //   formData: {
  //     affiProfileRequesterId: number;
  //     offerers: Array<number>;
  //     name: string;
  //     currency: string;
  //     distance: number;
  //     dropRadio: number;
  //     duration: number;
  //     id: number;
  //     observations: string;
  //     vehicleQty: number;
  //     passegerQty: number;
  //     pickupRadio: number;
  //     reverse: number;
  //     roundTrip: boolean;
  //     destination: [
  //       {
  //         accuracy: number;
  //         id: number;
  //         latitude: string;
  //         longitude: string;
  //         placeId: string;
  //         shortName: string;
  //       }
  //     ];
  //     serviceType: Array<number>;
  //     start: string;
  //     end: string;
  //     waitTime: number;
  //     passenger: number;
  //     paymentMethod: string;
  //     avoidHighways: boolean;
  //     avoidTolls: boolean;
  //     fastestRoute: boolean;
  //   },
  //   affiOSTravelId: number
  // ) {
  //   const command = new SendOSTravelAgreementCommand();

  //   command.setParameters(<ISendOSTravelAgreementCommandParameters>{
  //     affiProfileRequesterId: formData.affiProfileRequesterId,
  //     affiliateProfileList: formData.offerers,
  //     agreementName: formData.name,
  //     currency: formData.currency,
  //     distance: formData.distance,
  //     dropoffRadius: formData.dropRadio,
  //     duration: formData.duration,
  //     id: formData.id,
  //     notes: formData.observations,
  //     passengerQty: formData.passegerQty,
  //     pickupRadius: formData.pickupRadio,
  //     reverse: formData.reverse,
  //     roundTrip: formData.roundTrip,
  //     routeList: formData.destination,
  //     serviceTypesList: formData.serviceType,
  //     travelDate: formData.start,
  //     travelDueDate: formData.end,
  //     vehicleQty: formData.vehicleQty,
  //     waitingTime: formData.waitTime,
  //     passenger: formData.passenger,
  //     affiOSTravelId: affiOSTravelId,
  //     paymentMethod: formData.paymentMethod,
  //     avoidHighways: formData.avoidHighways,
  //     avoidTolls: formData.avoidTolls,
  //     fastestRoute: formData.fastestRoute
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as AffiliateProfilesPaginatedResponseDTO;
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _getEstablishedAffiOSTravels(requesterProfileId: string) {
  //   const command = new getEstablishedAffiOSTravelsCommand();
  //   command.setParameters(<IGetEstablishedAffiOSTravelsParameters>{
  //     requesterProfileId: requesterProfileId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }
  // _addCheckingAccountMovement(
  //   affiCheckingAccountId: number,
  //   amount: number,
  //   description: string,
  //   liquidationId: number,
  //   movementOrigin: string,
  //   movementOwnerId: number,
  //   movementType: string,
  //   paymentType: number,
  //   tag: string,
  //   travelId: number
  // ) {
  //   const command = new AddCheckingAccountMovementCommand();
  //   command.setParameters(<IaddCheckingAccountMovementCommandParameters>{
  //     affiCheckingAccountId: affiCheckingAccountId,
  //     amount: amount,
  //     description: description,
  //     liquidationId: liquidationId,
  //     movementOrigin: movementOrigin,
  //     movementOwnerId: movementOwnerId,
  //     movementType: movementType,
  //     paymentType: paymentType,
  //     tag: tag,
  //     travelId: travelId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => response)
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _getAffiliateCheckingAccountPaymentMethods() {
  //   const command = new GetAffiliateCheckingAccountPaymentMethodsCommand();
  //   return this._connectionService
  //     .Request(command)
  //     .map((data) => {
  //       let response = data;
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _getAffiliateCheckingAccountMovementTypes() {
  //   const command = new GetAffiliateCheckingAccountMovementTypesCommand();
  //   return this._connectionService
  //     .Request(command)
  //     .map((data) => {
  //       let response = data;
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _sendQuoteInvitation(
  //   sendQuoteInvitationCommandParameters: ISendQuoteInvitationCommandParameters
  // ) {
  //   const command = new SendQuoteInvitationCommand();
  //   command.setParameters(sendQuoteInvitationCommandParameters);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as SendQuoteInvitationDTO;
  //       this._notificationsService.showSuccessMessage(
  //         'toast.shared.edit',
  //         'toast.carrier.affiliate.modification_agreement_success'
  //       );
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _affiAcceptAgreement(
  //   acceptAffiAgremmentParameters: IAcceptAffiAgremmentParameters
  // ) {
  //   const command = new AcceptAffiAgremmentCommand();
  //   command.setParameters(acceptAffiAgremmentParameters);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as AcceptAffiAgreementResponse;
  //       this._notificationsService.showSuccessMessage(
  //         'toast.shared.edit',
  //         'toast.carrier.affiliate.accept_agreement_success'
  //       );
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // _affiUpdateDueDateAgreement(
  //   updateDueDateAffiAgreementParameters: IUpdateDueDateAffiAgreementParameters
  // ) {
  //   const command = new UpdateDueDAteAffiAgreementCommand();
  //   command.setParameters(updateDueDateAffiAgreementParameters);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       let data = response as UpdateDueDateAffiAgreementResponse;
  //       this._notificationsService.showSuccessMessage(
  //         'toast.shared.edit',
  //         'toast.carrier.affiliate.due_date_update_success'
  //       );
  //       return data;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }
  // sendQuotationDetailsEmail(
  //   parameters: IPostAffiOneShotTravelSendTravelReserveMailQuotizationParameters
  // ) {
  //   const command =
  //     new PostAffiOneShotTravelSendTravelReserveMailQuotizationCommand();
  //   command.setParameters(parameters);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  getPassengerWithCheckingAccountByCarrier() {
    const command = new GetPassengerWithCheckingAccountByCarrierCommand();
    command.setParameters(<IGetPassengerWithCheckingAccountByCarrierParameters>{
      carrierId: this._identityService.userId,
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          return throwError(() => new Error('Error al obtener pasajeros con cuenta corriente'));
        })
      );
  }

  getAssociatesByPrimaryPassengerId(passengerAccountId: string | number) {
    const command = new GetAssociatesByPrimaryPassengerIdCommand();
    command.setParameters(<IGetAssociatesByPrimaryPassengerIdParameters>{
      passengerAccountId: Number(passengerAccountId),
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          return throwError(() => new Error('Error al obtener asociados por pasajero principal'));
        })
      );
  }

  // mapRowData(data, acceptedValue, deletedValue){

  //   const contentArray = data.content.map((item)=>{

  //     const dataStatus = item.row.Col11 === 'DELETED' ? deletedValue : acceptedValue

  //     return {
  //       "companyId":Number(item.row.Col1),
  //       "companyName":item.row.Col2,
  //       "accountLimit":Number(item.row.Col3),
  //       "balance":Number(item.row.Col4),
  //       "available":Number(item.row.Col5),
  //       "nextLiquidation":Number(item.row.Col6),
  //       "lastLiquidation":item.row.Col7,
  //       "contractorId":Number(item.row.Col8),
  //       "checkingAccountId":Number(item.row.Col9),
  //       "lastLiquidationId":Number(item.row.Col10),
  //       "status":dataStatus,
  //       "liquidationId":Number(item.row.Col14),
  //     }
  //   })

  //   data.content = contentArray;
  //   return data
  // }

  // mapRowDataIndividuals(data:any){

  //   const contentArray = data.content.map((item)=>{

  //     return {
  //       "class":item.row.Col1,
  //       "passenger":item.row.Col2,
  //       "accountLimit":Number(item.row.Col3),
  //       "balance":Number(item.row.Col4),
  //       "available":Number(item.row.Col5),
  //       "nextLiquidation":Number(item.row.Col6),
  //       "lastLiquidation":item.row.Col7,
  //       "passenger_id":Number(item.row.Col8),
  //       "checkingAccountId":Number(item.row.Col9),
  //       "lastLiquidationId":Number(item.row.Col10),
  //       "hasTicketToConfirm":item.row.Col11,
  //       "liquidationId":Number(item.row.Col12),
  //     }
  //   })

  //   data.content = contentArray;
  //   return data
  // }

  // mapRowDataDrivers(data:any){
  //   const contentArray = data.content.map((item)=>{

  //     const operabilityStatus = item.row.Col11 == 1 ? this._translateService.instant('carrier.liquidations.driver.active_yes') : this._translateService.instant('carrier.liquidations.driver.active_no')

  //     return {
  //       "driverId":item.row.Col1,
  //       "code":item.row.Col2,
  //       "driver_name":item.row.Col3,
  //       "balance":Number(item.row.Col4),
  //       "to_liquidate":Number(item.row.Col5),
  //       "last_liquidation":item.row.Col6,
  //       "lastLiquidationId":Number(item.row.Col7),
  //       "operability":operabilityStatus
  //     }
  //   })

  //   data.content = contentArray;
  //   return data
  // }

  // mapRowDataOwners(data:any){
  //   const contentArray = data.content.map((item)=>{

  //   const collectsStatus = item.row.Col4 == 1 ? this._translateService.instant('carrier.liquidations.driver.active_yes') : this._translateService.instant('carrier.liquidations.driver.active_no')

  //     return {
  //       "owner_id":item.row.Col1,
  //       "code":Number(item.row.Col2),
  //       "owner_name":item.row.Col3,
  //       "collects_cash":collectsStatus,
  //       "balance":Number(item.row.Col5),
  //       "to_liquidate":Number(item.row.Col6),
  //       "last_liquidation":item.row.Col7,
  //       "last_liquidation_id":item.row.Col8,
  //       "travel_surrender_id":item.row.Col9,
  //       "carrier":item.row.Col10,
  //     }
  //   })

  //   data.content = contentArray;
  //   return data
  // }

  // updatePlatformStatusRTDB(nodo: string) {
  //   const command = new updatePlatformStatusInRTDBCommand();
  //   command.setParameters(<IUpdatePlatformStatusInRTDBParameters>{
  //     carrierId: this._identityService.userId,
  //     nodo: nodo
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // getTaxesAndFees() {
  //   const command = new GetTaxesAndFeesCommand();
  //   command.setParameters(<IGetTaxesAndFeesParameters>{
  //     carrierId: +this._identityService.userId,
  //   });
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // addConcept(name: string, fixValue: number) {
  //   const command = new AddConceptCommand();
  //   command.setParameters(<IAddConceptCommandParameters>{
  //     name: name,
  //     fixedValue: fixValue,
  //     carrierId: +this._identityService.userId,
  //     userId: +this._identityService.subUserId
  //   });
  //   return this._connectionService.Request(command).map((response) => {
  //     return response;
  //   }).catch((error) => {
  //     this._notificationsService.showHttpErrorMessage(
  //       'toast.shared.error_code.0',
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  // }

  // deleteConcept(conceptId: number) {
  //   const command = new DeleteConceptCommand();
  //   command.setParameters(<DeleteConceptCommandParameters>{
  //     carrierId: +this._identityService.userId,
  //     id: conceptId,
  //     userId: +this._identityService.subUserId
  //   });
  //   return this._connectionService.Request(command).map((response) => {
  //     return response;
  //   }).catch((error) => {
  //     this._notificationsService.showHttpErrorMessage(
  //       'toast.shared.error_code.0',
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  // }

  // editConcept(name: string, fixValue: number, conceptId: number) {
  //   const command = new EditConceptCommand();
  //   command.setParameters(<IEditConceptCommandParameters>{
  //     name: name,
  //     fixedValue: fixValue,
  //     carrierId: +this._identityService.userId,
  //     userId: +this._identityService.subUserId,
  //     id: conceptId
  //   });
  //   return this._connectionService.Request(command).map((response) => {
  //     return response;
  //   }).catch((error) => {
  //     this._notificationsService.showHttpErrorMessage(
  //       'toast.shared.error_code.0',
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  // }

  // addTax(name: string, percent: number) {
  //   const command = new AddTaxCommand();
  //   command.setParameters(<IAddTaxCommandParameters>{
  //     name: name,
  //     percent: percent,
  //     carrierId: +this._identityService.userId,
  //     userId: +this._identityService.subUserId
  //   });
  //   return this._connectionService.Request(command).map((response) => {
  //     return response;
  //   }).catch((error) => {
  //     this._notificationsService.showHttpErrorMessage(
  //       'toast.shared.error_code.0',
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  // }

  // deleteTax(taxId: number) {
  //   const command = new DeleteTaxCommand();
  //   command.setParameters(<DeleteTaxCommandParameters>{
  //     carrierId: +this._identityService.userId,
  //     id: taxId,
  //     userId: +this._identityService.subUserId
  //   });
  //   return this._connectionService.Request(command).map((response) => {
  //     return response;
  //   }).catch((error) => {
  //     this._notificationsService.showHttpErrorMessage(
  //       'toast.shared.error_code.0',
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  // }

  // editTax(name: string, percent: number, id: number) {
  //   const command = new EditTaxCommand();
  //   command.setParameters(<IEditTaxCommandParameters>{
  //     id: id,
  //     name: name,
  //     percent: percent,
  //     carrierId: +this._identityService.userId,
  //     userId: +this._identityService.subUserId,
  //   });
  //   return this._connectionService.Request(command).map((response) => {
  //     return response;
  //   }).catch((error) => {
  //     this._notificationsService.showHttpErrorMessage(
  //       'toast.shared.error_code.0',
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  // }

  getOwners(carrierId: string) {
    const command = new GetOwnersFindCommand();
    command.setParameters({ carrierId });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any[]),
        catchError(error => {
          return throwError(() => new Error('Error al obtener propietarios'));
        })
      );
  }

  getPassengerByArea(areaId: string): Observable<any> {
    const command = new GetPassengerByAreaCommand();
    command.setParameters({ areaId });
    return this._connectionService.Request(command as any).pipe(
      map(response => response as any),
      catchError(error => {
        this._notificationsService.showHttpErrorMessage(this.titleMessage, error);
        return throwError(() => error);
      })
    );
  }

  // updateTaxesValues(taxesValues: TaxUpdate) {
  //   const command = new UpdateTaxesCommand();
  //   command.setParameters(<IUpdateTaxesCommandParameters>{
  //     concepts: taxesValues.concepts,
  //     userId: +this._identityService.subUserId,
  //     carrierId: +this._identityService.userId
  //   });
  //   return this._connectionService.Request(command).map((response) => {
  //     return response;
  //   }).catch((error) => {
  //     this._notificationsService.showHttpErrorMessage(
  //       'toast.shared.error_code.0',
  //       error
  //     );
  //     return Observable.throw(false);
  //   });
  // }

  // --- Recurring Trip Methods ---

  public getRecurringTrips(
    carrierId: number,
    page: number,
    size: number,
    column: string,
    sort: string,
    status: string,
    find: string = ''
  ): Observable<IGetRecurringTripResponse> {
    const command = new GetRecurringTripCommand();
    command.setParameters(<IGetRecurringTripCommandParameters>{
      carrierId,
      page,
      size,
      column,
      sort,
      status,
      find,
    });
    return this._connectionService.Request(command).pipe(
      map((response) => response as IGetRecurringTripResponse),
      catchError((error) => throwError(() => error))
    );
  }

  public getCanceledRecurringTrips(
    carrierId: number,
    page: number,
    size: number,
    column: string,
    sort: string,
    find: string = ''
  ): Observable<IGetCanceledRecurringTripResponse> {
    const command = new GetCanceledRecurringTripCommand();
    command.setParameters(<IGetCanceledRecurringTripCommandParameters>{
      carrierId,
      page,
      size,
      column,
      sort,
      find,
    });
    return this._connectionService.Request(command).pipe(
      map((response) => response as IGetCanceledRecurringTripResponse),
      catchError((error) => throwError(() => error))
    );
  }

  public deleteRecurringTrip(
    carrierId: number,
    recurringId: number,
    reasonToCancel: string,
    userId: number
  ): Observable<ICommandResponse> {
    const command = new DeleteRecurringTripCommand();
    command.setParameters(<IDeleteRecurringTripCommandParameters>{
      carrierId,
      recurringId,
      reasonToCancel,
      userId,
    });
    return this._connectionService.Request(command).pipe(
      map((response) => response as ICommandResponse),
      catchError((error) => throwError(() => error))
    );
  }

  public editRecurringTrip(
    params: IEditRecurringTripCommandParameters
  ): Observable<ICommandResponse> {
    const command = new EditRecurringTripCommand();
    command.setParameters(params);
    return this._connectionService.Request(command).pipe(
      map((response) => response as ICommandResponse),
      catchError((error) => throwError(() => error))
    );
  }

  public postSendRecurrentNote(recurringId: number, note: string): Observable<any> {
    const command = new PostSendRecurrentNoteCommand(recurringId, note);
    command.setParameters(<IPostSendRecurrentNote>{
      note: note,
    });
    return this._connectionService.Request(command).pipe(
      map((response) => response),
      catchError((error) => throwError(() => error))
    );
  }

  getSurrendersReport(
    page: number,
    size: number,
    column: string,
    sort: SortEnum,
    driverId?: string,
    ownerId?: string,
    domain?: string,
    from?: string,
    to?: string
  ): Observable<SurrenderReportPagesResponseDTO> {
    const command = new GetSurrenderReportCommand();
    command.setParameters(<IGetSurrenderReportCommandParameters>{
      carrierId: this._identityService.userId,
      page,
      size,
      column,
      sort,
      driverId,
      ownerId,
      domain,
      from,
      to,
    });
    return this._connectionService.Request(command).pipe(
      map(response => response as SurrenderReportPagesResponseDTO),
      catchError(error => throwError(() => error))
    );
  }

  getTotalsSurrender(
    driverId?: string,
    ownerId?: string,
    domain?: string,
    from?: string,
    to?: string
  ): Observable<IGetTotalsSurrenderResponse> {
    const command = new GetTotalsSurrenderCommand();
    command.setParameters(<IGetTotalsSurrenderCommandParameters>{
      carrierId: this._identityService.userId,
      driverId,
      ownerId,
      domain,
      from,
      to,
    });
    return this._connectionService.Request(command).pipe(
      map(response => response as IGetTotalsSurrenderResponse),
      catchError(error => throwError(() => error))
    );
  }

  getSurrenderPdfById(surrenderId: number): Observable<Blob> {
    const apiUrl = this._configService.config.apiUrl;
    const carrierId = this._identityService.userId;
    const token = this._identityService.sessionToken;
    const url = `${apiUrl}carriers/${carrierId}/travels/surrender?surrenderId=${surrenderId}`;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this._http.post(url, null, { headers, responseType: 'blob' });
  }

  syncWithOdn(carrierId: number, travelId: string) {
    const command = new SyncWithOdnCommand();
    command.setParameters(<ISyncWithOdnParameters>{
      carrierId: carrierId,
      travelId: travelId,
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as any),
        catchError(error => {
          return throwError(() => error);
        })
      );
  }
  // ─── MX-5600: Operations Control Dashboard ─────────────────────

  /**
   * Get current travel status for dashboard KPI cards.
   * Endpoint: GET carriers/travelsCurrentStatus/carrier/{carrierId}
   */
  public getTravelsCurrentStatus(): Observable<TravelsCurrentStatus> {
    const command = new GetTravelsCurrentStatusCommand();
    command.setParameters(<IGetTravelCurrentStatusCommandParameters>{
      carrierUserId: this._identityService.userId
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => response as TravelsCurrentStatus),
        catchError(error => {
          console.error('Error fetching travel status:', error);
          return throwError(() => error);
        })
      );
  }

  /**
   * Get drivers dashboard data (all drivers with full state, vehicle, position).
   * Endpoint: GET carriers/{carrierId}/drivers/dashboard
   */
  public getDriversDashboard(): Observable<DriverDashboardDTO[]> {
    const command = new GetDriversDashboardCommand();
    command.setParameters(<IGetDriversDashboardParameters>{
      carrierUserId: this._identityService.userId
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response: IGetDriversDashboardResponse) => response.content || []),
        catchError(error => {
          console.error('Error fetching drivers dashboard:', error);
          return throwError(() => error);
        })
      );
  }

  /**
   * Get drivers via paginated endpoint (returns full driver data including vehicle, position, state).
   * Endpoint: GET carriers/{carrierId}/drivers/paginated
   */
  public getDriversPaginated(carrierId: string): Observable<any> {
    const command = new GetDriversDashboardCommand();
    command.setParameters(<IGetDriversDashboardParameters>{
      carrierUserId: carrierId
    });
    // Override the URL to use the paginated endpoint
    (command as any)._commandUrl = `carriers/${carrierId}/drivers/paginated?page=1&size=999&column=id&sort=ASC&states=&find=`;
    return this._connectionService
      .Request(command)
      .pipe(
        map((response: any) => response),
        catchError(error => {
          console.error('Error fetching drivers paginated:', error);
          return throwError(() => error);
        })
      );
  }

  /**
   * Get driver last known positions for the map.
   * Endpoint: GET carriers/{carrierId}/drivers/lastPlace?state=
   * NOTE: Returns HTTP 500 on staging (SQL error in backend) — use gracefully
   */
  public getDriversLastPlaces(): Observable<IGetDriversLastPlacesResponse[]> {
    const command = new GetDriversLastPlacesCommand();
    command.setParameters(<IGetDriversLastPlacesParameters>{
      carrierUserId: this._identityService.userId
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map((response: any) => Array.isArray(response) ? response : []),
        catchError(error => {
          console.error('Error fetching driver positions:', error);
          return throwError(() => error);
        })
      );
  }
}
